import imageCompression from 'browser-image-compression';

export async function compressImage(file: File, maxSizeMB = 1, maxWidthOrHeight = 1920): Promise<File> {
  if (!file.type.startsWith('image/')) return file;
  const options = {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker: true,
    initialQuality: 0.8,
  };
  try {
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (e) {
    return file;
  }
}
